"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2018 Flowhub UG
//     NoFlo may be freely distributed under the MIT license
var getParams = require('get-function-params');

var _require = require('./Component'),
    Component = _require.Component; // ## asComponent generator API
//
// asComponent is a helper for turning JavaScript functions into
// NoFlo components.
//
// Each call to this function returns a component instance where
// the input parameters of the given function are converted into
// NoFlo inports, and there are `out` and `error` ports for the
// results of the function execution.
//
// Variants supported:
//
// * Regular synchronous functions: return value gets sent to `out`.
//   Thrown errors get sent to `error`
// * Functions returning a Promise: resolved promises get sent to `out`,
//   rejected promises to `error`
// * Functions taking a Node.js style asynchronous callback: `err` argument
//   to callback gets sent to `error`, result gets sent to `out`
//
// Usage example:
//
//     exports.getComponent = function () {
//       return noflo.asComponent(Math.random, {
//         description: 'Generate a random number',
//       });
//     };
//
// ### Wrapping built-in functions
//
// Built-in JavaScript functions don't make their arguments introspectable.
// Because of this, these cannot be directly converted to components.
// You'll have to provide a wrapper JavaScript function to make  the arguments appear as ports.
//
// Example:
//
//     exports.getComponent = function () {
//       return noflo.asComponent(function (selector) {
//         return document.querySelector(selector);
//       }, {
//         description: 'Return an element matching the CSS selector',
//         icon: 'html5',
//       });
//     };
//
// ### Default values
//
// Function arguments with a default value are supported in ES6 environments.
// The default arguments are visible via the component's port interface.
//
// However, ES5 transpilation doesn't work with default values.
// In these cases the port with a default won't be visible. It is
// recommended to use default values only with components that don't need to run in legacy browsers.


exports.asComponent = function asComponent(func, options) {
  var hasCallback = false;
  var params = getParams(func).filter(function (p) {
    if (p.param !== 'callback') {
      return true;
    }

    hasCallback = true;
    return false;
  });
  var c = new Component(options);
  params.forEach(function (p) {
    var portOptions = {
      required: true
    };

    if (typeof p["default"] !== 'undefined') {
      portOptions["default"] = p["default"];
      portOptions.required = false;
    }

    c.inPorts.add(p.param, portOptions);
    c.forwardBrackets[p.param] = ['out', 'error'];
  });

  if (!params.length) {
    c.inPorts.add('in', {
      datatype: 'bang'
    });
  }

  c.outPorts.add('out');
  c.outPorts.add('error');
  c.process(function (input, output) {
    var values;

    if (params.length) {
      for (var i = 0; i < params.length; i += 1) {
        var p = params[i];

        if (!input.hasData(p.param)) {
          return;
        }
      }

      values = params.map(function (p) {
        return input.getData(p.param);
      });
    } else {
      if (!input.hasData('in')) {
        return;
      }

      input.getData('in');
      values = [];
    }

    if (hasCallback) {
      // Handle Node.js style async functions
      values.push(function (err, res) {
        if (err) {
          output.done(err);
          return;
        }

        output.sendDone(res);
      });
      func.apply(void 0, _toConsumableArray(values));
      return;
    }

    var res = func.apply(void 0, _toConsumableArray(values));

    if (res && _typeof(res) === 'object' && typeof res.then === 'function') {
      // Result is a Promise, resolve and handle
      res.then(function (val) {
        return output.sendDone(val);
      }, function (err) {
        return output.done(err);
      });
      return;
    }

    output.sendDone(res);
  });
  return c;
};